module.exports = __webpack_public_path__ + "static/media/down.96d0e564.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/down.png
 ** module id = 321
 ** module chunks = 0
 **/